module.exports = __webpack_public_path__ + "img/recommend-003.4af86b67.png";